var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7674 0C19.4953 0 22 2.6158 22 6.5076V15.4924C22 19.3842 19.4953 22 15.7663 22H6.2315C2.5036 22 0 19.3842 0 15.4924V6.5076C0 2.6158 2.5036 0 6.2315 0H15.7674ZM15.7674 1.65H6.2315C3.4485 1.65 1.65 3.5563 1.65 6.5076V15.4924C1.65 18.4437 3.4485 20.35 6.2315 20.35H15.7663C18.5504 20.35 20.35 18.4437 20.35 15.4924V6.5076C20.35 3.5563 18.5515 1.65 15.7674 1.65ZM10.999 5.37196C11.4544 5.37196 11.824 5.74156 11.824 6.19696V10.5266L15.1526 12.5099C15.5431 12.7442 15.6718 13.2502 15.4386 13.6418C15.2835 13.9003 15.0096 14.0444 14.7291 14.0444C14.585 14.0444 14.4398 14.007 14.3067 13.9289L10.5766 11.7036C10.328 11.554 10.174 11.2845 10.174 10.9952V6.19696C10.174 5.74156 10.5436 5.37196 10.999 5.37196Z",
    fill: "#594AD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.5ddee298b615bd8ae0976057f257d43c.svg";
export { ForwardRef as ReactComponent };